<template>
    <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" status-icon label-width="120px" class="demo-ruleForm scorll-auto">
            <el-form-item label="商品名称" prop="name">
                <el-input v-model="ruleForm.name" maxlength="80" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="商品主图" prop="zhuFile">
                <el-upload
                    style="display: inline-block"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :file-list="ruleForm.zhuFile"
                    list-type="picture-card"
                    :on-change="handleChange1"
                    :auto-upload="false"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove1"
                    :limit="1"
                    :class="ruleForm.zhuFile.length == 1 ? 'mf' : ''"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
                <span style="position: relative; top: 116px; left: 10px">{{ ruleForm.zhuFile.length + "/" + 1 }}</span>
            </el-form-item>
            <el-form-item>
                <el-link type="danger" :underline="false">图片尺寸建议600*600像素内，上传的图片默认自然排序</el-link>
            </el-form-item>
            <el-form-item label="商品轮播图" prop="lbFile">
                <el-upload
                    style="display: inline-block"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :file-list="ruleForm.lbFile"
                    :multiple="true"
                    list-type="picture-card"
                    :on-change="handleChange2"
                    :auto-upload="false"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove2"
                    :limit="5"
                    :class="ruleForm.imgs_lists.length == 5 ? 'mf' : ''"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
                <span style="position: relative; top: 116px; left: 10px">{{ ruleForm.imgs_lists.length + "/" + 5 }}</span>
            </el-form-item>
            <el-form-item label="商品详情图" prop="detailFile">
                <el-upload
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :multiple="true"
                    :file-list="ruleForm.detailFile"
                    list-type="picture-card"
                    :on-change="handleChange3"
                    :auto-upload="false"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove3"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="分类类型" prop="region">
                <el-select v-model="ruleForm.region" placeholder="请选择分类类型">
                    <el-option label="虚拟商品(暂未开放，尽请期待)" :disabled="true" value="2001"></el-option>
                    <el-option label="实物商品" value="2000"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="品牌类型" prop="goods_brands_id">
                <el-select v-model="ruleForm.goods_brands_id" filterable remote reserve-keyword placeholder="请输入关键词" :remote-method="remoteMethod" :loading="loading">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="商品分类" prop="prolei">
                <el-cascader style="width: 35%" filterable  clearable :props="{ value: 'id', label: 'name' }" v-model="ruleForm.prolei" :options="customers"></el-cascader>
            </el-form-item>
            <el-form-item label="商品参数" prop="attribute" required>
                <div class="bg">
                    <el-row :gutter="40">
                        <el-col :span="12">
                            <el-row :gutter="10">
                                <el-col :span="6"><label for="">商品重量</label></el-col>
                                <el-col :span="18"
                                    ><el-input v-model="ruleForm.attribute.net_weight" clearable> <template slot="append">kg</template></el-input></el-col
                                >
                            </el-row>
                        </el-col>
                        <el-col :span="12">
                            <el-row :gutter="10">
                                <el-col :span="6"><label for="">型号</label></el-col>
                                <el-col :span="18"><el-input v-model="ruleForm.attribute.marque" clearable></el-input></el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="12">
                            <el-row :gutter="10">
                                <el-col :span="6"><label for="">包装尺寸</label></el-col>
                                <el-col :span="18"
                                    ><el-input v-model="ruleForm.attribute.volume" clearable>
                                        <template slot="append">cm</template>
                                    </el-input></el-col
                                >
                            </el-row>
                        </el-col>
                        <el-col :span="12">
                            <el-row :gutter="10">
                                <el-col :span="6"><label for="">产地</label></el-col>
                                <el-col :span="18"><el-input v-model="ruleForm.attribute.country_of_origin" clearable></el-input></el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </div>
            </el-form-item>
            <el-form-item label="规格" :required="true">
                <el-radio v-model="Spec" label="1">单规格</el-radio>
                <el-radio v-model="Spec" label="2">多规格</el-radio>
            </el-form-item>
            <el-form-item label="商品销售价" prop="xsj">
                <el-input-number v-model="ruleForm.xsj" :min="0" style="width: 250px; margin-right: 5px" placeholder="请输入销售价(元)"></el-input-number>
            </el-form-item>
            <el-form-item label="商品市场价" prop="scj">
                <el-input-number v-model="ruleForm.scj" :min="0" style="width: 250px; margin-right: 5px" placeholder="商品市场价(元)"></el-input-number>
            </el-form-item>
            <el-form-item v-if="Spec == 1" v-model="ruleForm.kc" prop="kc" label="库存">
                <el-input-number v-model="ruleForm.kc" :min="0" style="width: 250px; margin-right: 5px" placeholder="库存"></el-input-number>
            </el-form-item>
            <el-form-item v-if="Spec == 2" label="商品规格" prop="guigeList">
                <div class="guige">
                    <el-select v-model="ggname" placeholder="请选择规格名">
                        <el-option v-for="gui in Guigename" :key="gui.id" :label="gui.title" :value="gui.id"></el-option>
                    </el-select>
                    <el-input v-if="insertggm" v-model="guititle" placeholder="请输入规格名" style="width: 200px; margin-left: 20px" clearable @clear="insertggm = false"></el-input>
                    <el-button v-if="insertggm" @click="insertGgm" type="primary" style="margin-left: 10px">确认</el-button>
                    <el-button type="primary" style="margin-left: 10px" @click="insertggm = true"><i class="el-icon-plus"></i></el-button>
                    <el-input placeholder="请输入规格值" v-model="ggvalue" style="width: 200px; margin-left: 20px" clearable></el-input>
                    <el-button type="primary" style="margin-left: 10px" @click="insertYI">生成</el-button>
                </div>
                <div class="items" v-for="(item, index) in ruleForm.guigeList" :key="index" style="margin-top: 10px; background: #cccccc7a; padding: 10px; border-radius: 8px; box-sizing: border-box">
                    <div class="top">
                        <el-button type="warning">{{ getGuival(item.ggname) }}</el-button
                        ><el-button @click="deleteYI(item)" style="margin-left: 10px" type="danger"><i class="el-icon-delete"></i></el-button>
                    </div>
                    <div class="yiji" style="margin-top: 10px">
                        <span style="margin-left: 10px">规格名：</span>
                        <el-button>{{ item.value }}</el-button>
                        <el-select v-model="item.gg2name" placeholder="请选择规格名" style="margin-left: 10px" :disabled="item.gg2name != ''">
                            <el-option :disabled="gui.id == item.ggname" v-for="gui in Guigename" :key="gui.id" :label="gui.title" :value="gui.id"></el-option>
                        </el-select>
                        <!-- <el-button v-if="item.gg2name!=''" @click="item.gg2name=''" type="primary" style="margin-left:10px;">取消</el-button> -->
                        <el-input placeholder="请输入规格值" v-model="item.gg2value" style="width: 200px; margin-left: 20px" clearable></el-input>
                        <el-button type="primary" style="margin-left: 10px" @click="insertER(item)">生成</el-button>
                        <div class="erji" v-for="(item2, index) in item.childern2" :key="index" style="margin-top: 10px">
                            <div class="top" v-if="index == 0">
                                <el-button type="warning">{{ getGuival(item2.name) }}</el-button
                                ><el-button @click="deleteers(item)" style="margin-left: 10px" type="danger"><i class="el-icon-delete"></i></el-button>
                            </div>
                            <div class="erjiConitem" style="margin-top: 10px">
                                <span style="margin-left: 10px">规格值：</span>
                                <el-button>{{ item2.value }}</el-button>
                                <span style="margin-left: 10px">销售价：</span>
                                <el-input-number v-model="item2.xsj" :min="0" style="width: 180px; margin-right: 5px; margin-top: 10px"></el-input-number>
                                <span style="margin-left: 10px">市场价：</span>
                                <el-input-number v-model="item2.scj" :min="0" style="width: 180px; margin-right: 5px; margin-top: 10px"></el-input-number>
                                <span style="margin-left: 10px">库存：</span>
                                <el-input-number v-model="item2.kc" :min="0" style="width: 180px; margin-right: 5px; margin-top: 10px"></el-input-number>
                                <el-button @click="deleteER(item, item2)" style="margin-left: 10px" type="danger"><i class="el-icon-delete"></i></el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <el-button v-if="ruleForm.guigeList.length > 0" type="primary" style="margin-left: 10px; margin-top: 10px" @click="initTable">生成规格明细</el-button>
                <div v-if="ruleForm.guigeList.length > 0" class="table">
                    <el-table :data="tableData" style="width: 100%">
                        <el-table-column prop="name" label="规格值*规格值"> </el-table-column>
                        <el-table-column prop="xsj" label="销售价(元)"> </el-table-column>
                        <el-table-column prop="scj" label="市场价(元)"> </el-table-column>
                        <el-table-column prop="kc" label="库存"> </el-table-column>
                    </el-table>
                </div>
            </el-form-item>
            <el-form-item label="快递费" :required="true">
                <!-- 9.16产品要求隐藏 -->
                <!-- <p>
                    <el-radio v-model="yf" label="1">统一运费</el-radio>
                    <span v-if="yf == '1'"><el-input-number placeholder="运费" v-model="yfprice" :min="0" style="width: 180px; margin-left: 10px; margin-right: 5px"></el-input-number>元</span>
                </p> -->
                <div class="flex">
                    <el-radio v-model="yf" label="2">包邮</el-radio>
                    <el-input v-model="ruleForm.send_goods_time" style="width: 240px" clearable>
                        <template slot="append">小时内发货</template>
                    </el-input>
                </div>
            </el-form-item>
            <el-form-item label="发货地址" prop="warehouse_address_id" class="close" required>
                <el-select v-model="ruleForm.warehouse_address_id" placeholder="请选择发货地址" clearable>
                    <el-option v-for="item in warehouseList" :key="item.id" :label="item.title" :value="item.id"></el-option>
                </el-select>
                <el-button type="primary" size="medium" style="margin-left: 20px" @click="showDeliveryAddress">添加</el-button>
            </el-form-item>
            <el-form-item label="是否自动上架" prop="put_on_sale">
                <el-radio-group v-model="ruleForm.put_on_sale">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否支持7天无理由退货" prop="unconditional_return">
                <el-radio-group v-model="ruleForm.unconditional_return">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button :disabled="disabledOK" @click="quxiao">取消</el-button>
                <el-button type="primary" @click="submitForm" :loading="disabledOK">确定</el-button>
            </el-form-item>
        </el-form>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
    name: "insert",
    data() {
        return {
            options: [],
            ruleForm: {
                warehouse_address_id: "",
                send_goods_time: "",
                name: "",
                region: "2000", //分类
                goods_brands_id: "",
                prolei: [], //商品分类
                zhuFile: [], //主图
                lbFile: [], //轮播图
                guigeList: [],
                xsj: undefined, //销售价
                scj: undefined, //市场价
                kc: undefined, //库存
                detailFile: [], //详情图
                imgs_mains: "", //主图url
                imgs_lists: [], //轮播图url
                goods_detail_imgs_id: [], //详情图id
                put_on_sale: 0,
                unconditional_return: 1,
                attribute: {
                    net_weight: "",
                    marque: "",
                    volume: "",
                    country_of_origin: "",
                },
            },
            titlesOk: true,
            deleteId: [],
            disabledOK: false,
            guititle: "", //规格名添加
            customers: [],
            Guigename: [], //规格名列表
            ggname: "",
            ggvalue: "",
            Spec: "1", //规格(单或多)
            yf: "2", //运费
            yfprice: undefined, //运费价格
            dialogImageUrl: "",
            dialogVisible: false,
            insertggm: false, //添加规格
            tableData: [],
            rules: {
                send_goods_time: [
                    {
                        required: true,
                        message: "请填写发货时间",
                        trigger: "blur",
                    },
                ],
                warehouse_address_id: [
                    {
                        required: true,
                        message: "请选择发货地址",
                        trigger: "change",
                    },
                ],
                name: [
                    {
                        min: 0,
                        max: 40,
                        message: "商品名称不能超过40个字符",
                        trigger: "blur",
                    },
                ],
                zhuFile: [{ required: true, message: "请上传主图" }],
                lbFile: [{ required: true, message: "请上传商品轮播图" }],
                region: [
                    {
                        required: true,
                        message: "请选择分类类型",
                        trigger: "blur",
                    },
                ],
                goods_brands_id: [
                    {
                        required: true,
                        message: "请选择品牌类型",
                        trigger: "blur",
                    },
                ],
                prolei: [
                    {
                        required: true,
                        message: "请选择商品分类",
                        trigger: "blur",
                    },
                ],
                xsj: [
                    {
                        required: true,
                        message: "请填写销售价格",
                        trigger: "blur",
                    },
                ],
                scj: [
                    {
                        required: true,
                        message: "请填写市场价",
                        trigger: "blur",
                    },
                ],
                kc: [{ required: true, message: "请填写库存", trigger: "blur" }],
                detailFile: [
                    {
                        required: true,
                        message: "请上传商品详情图",
                        trigger: "blur",
                    },
                ],
                guigeList: [
                    {
                        required: true,
                        message: "请填写商品规格",
                        trigger: "blur",
                    },
                ],
                put_on_sale: [
                    {
                        required: true,
                        message: "请选择是否自动上架",
                        trigger: "change",
                    },
                ],
                unconditional_return: [
                    {
                        required: true,
                        message: "请选择是否支持7天无理由退货",
                        trigger: "change",
                    },
                ],
            },
            timer: null,
            loading: false,
        };
    },
    created() {
        this.leixChange();
        this.bindName();
        this.Bind();
    },
    props: {
        ids: {
            type: Number,
        },
        warehouseList: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    methods: {
        ...mapActions({
            getGoodLei: "commodity/getGoodLei",
            uploadFile: "commodity/uploadFile",
            getGuiNameList: "commodity/getGuiNameList",
            insertGuiName: "commodity/insertGuiName",
            proUpdate: "commodity/proUpdate",
            insertGuige: "commodity/insertGuige",
            getProDetails: "commodity/newGoodsDetail",
            getGuiDetails: "commodity/getGuiDetails",
            getGoodsList: "commodity/newGoodsList",
            getListbrand: "commodity/getListbrand",
        }),
        getSearchData(query) {
            this.getListbrand({ name: query }).then((res) => {
                this.loading = false;
                if (res.code == 1) {
                    this.options = res.data.list.map((item) => {
                        return { value: item.id, label: item.name };
                    });
                } 
            });
        },
        remoteMethod(query) {
            if (query !== "") {
                this.loading = true;
                if (this.timer) {
                    clearTimeout(this.timer);
                }
                this.timer = setTimeout(() => {
                    this.getSearchData(query);
                }, 800);
            } else {
                this.options = [];
            }
        },
        showDeliveryAddress() {
            this.$emit("showDeliveryAddress");
        },
        Bind() {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.getProDetails({
                token: this.$store.state.token,
                id: this.ids,
            }).then((res) => {
                if (res.code == 1) {
                    this.options = [{ value: res.data.goods_brands_id, label: res.data.goods_brands_name }];
                    this.ruleForm.name = res.data.tits;
                    this.ruleForm.region = res.data.classifys_type_id;
                    this.ruleForm.goods_brands_id = res.data.goods_brands_id;
                    this.Spec = res.data.goods_specifications_type_id;
                    this.ruleForm.xsj = res.data.prices_mains;
                    this.ruleForm.scj = res.data.prices_defaults;
                    this.ruleForm.kc = res.data.merchandise_inventory;
                    this.yf = res.data.express_fee;
                    this.yfprice = res.data.express_fee_price;
                    this.ruleForm.prolei = [Number(res.data.sorts_tops), Number(res.data.second_sorts), Number(res.data.sorts)];
                    console.log(this.ruleForm.prolei);
                    this.ruleForm.zhuFile = [
                        {
                            url: res.data.imgs_mains,
                        },
                    ];
                    this.yf = "2";
                    this.ruleForm.warehouse_address_id = res.data.warehouse_address_id;
                    this.ruleForm.send_goods_time = res.data.send_goods_time;
                    this.ruleForm.attribute = {
                        net_weight: res.data.net_weight,
                        marque: res.data.marque,
                        volume: res.data.volume,
                        country_of_origin: res.data.country_of_origin,
                    };
                    this.ruleForm.imgs_mains = res.data.imgs_mains;
                    this.ruleForm.put_on_sale = Number(res.data.put_on_sale);
                    this.ruleForm.unconditional_return = Number(res.data.unconditional_return);
                    let a = res.data.imgs_lists.split(",");
                    for (let i = 0; i < a.length; i++) {
                        this.ruleForm.lbFile.push({
                            url: a[i],
                        });
                        this.ruleForm.imgs_lists.push({
                            file: "1",
                            url: a[i],
                        });
                    }
                    let b = res.data.goods_detail_imgs;
                    for (let i = 0; i < b.length; i++) {
                        this.ruleForm.detailFile.push({
                            url: b[i].urls,
                        });
                        this.ruleForm.goods_detail_imgs_id.push({
                            file: "1",
                            id: b[i].id,
                            url: b[i].urls,
                        });
                    }
                    this.getGuiDetails({
                        token: this.$store.state.token, //必填 商户验证token
                        list_flg: 1, //非必填  转成两层父子结构
                        column: ["*"], //非必填  展示字段
                        filter: {
                            goods_mains_id: parseInt(res.data.id), //商品表id
                        },
                        offset: 0,
                        limit: 0,
                    }).then((msg) => {
                        loading.close();
                        if (msg.code == 1) {
                            // console.log(msg);
                            let list = msg.data.list_data;
                            if (list && list.length > 0) {
                                let listit = [];
                                for (let i = 0; i < list.length; i++) {
                                    let child = [];
                                    for (let j = 0; j < list[i].child.length; j++) {
                                        child.push({
                                            id: list[i].child[j].id,
                                            name: list[i].child_id,
                                            value: list[i].child[j].title.split(",")[1],
                                            xsj: list[i].child[j].prices_mains,
                                            scj: list[i].child[j].prices_defaults,
                                            kc: list[i].child[j].merchandise_inventory,
                                        });
                                    }
                                    listit.push({
                                        ggname: list[i].upid,
                                        value: list[i].title,
                                        gg2name: "",
                                        gg2value: "",
                                        namein: "",
                                        childern2: child,
                                    });
                                }
                                this.ruleForm.guigeList = listit;
                                this.initTable();
                            }
                        } else {
                            this.$message.error(msg.msg);
                        }
                    });
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        submitForm() {
            if (!this.titlesOk) this.$message.warning("商品名称重复，请更改");
            this.$refs["ruleForm"].validate((valid) => {
                let k = true;
                if (parseInt(this.yf) == 1 && this.yfprice == undefined) {
                    this.$message.warning("请填写运费！");
                    k = false;
                }
                if (this.ruleForm.guigeList.length > 0 && this.ruleForm.guigeList[0].childern2.length <= 0) {
                    this.$message.warning("请填写规格！");
                    k = false;
                }
                if (valid && k) {
                    this.disabledOK = true;
                    let detal = [];
                    for (let i = 0; i < this.ruleForm.goods_detail_imgs_id.length; i++) {
                        detal.push(this.ruleForm.goods_detail_imgs_id[i].id);
                    }
                    let lb = [];
                    for (let i = 0; i < this.ruleForm.imgs_lists.length; i++) {
                        lb.push(this.ruleForm.imgs_lists[i].url);
                    }
                    let data = {
                        id: this.ids,
                        token: this.$store.state.token, //必填  商户登录后的token
                        sorts_tops: this.ruleForm.prolei[0], //一级商品分类id
                        sorts: this.ruleForm.prolei[2], //三级商品分类id
                        tits: this.ruleForm.name, //商品标题
                        tits_alls: this.ruleForm.name, //商品标题全称， 暂时和商品标题传一样的
                        imgs_mains: this.ruleForm.imgs_mains, //商品主图
                        goods_brands_id: this.ruleForm.goods_brands_id,
                        // status: 1, //商品状态  1 已上架  0 下架
                        goods_detail_imgs_id: detal.join(","), //商品详情图片id  逗号分割
                        goods_specifications_type_id: this.Spec, //规格类型   1 单规格  2 多规格
                        prices_defaults: this.ruleForm.scj, //标准价
                        prices_mains: this.ruleForm.xsj, //零售价
                        express_fee: this.yf, //快递费类型  1 统一运费  2 包邮
                        classifys_type_id: parseInt(this.ruleForm.region), //商品分类类型   2000 实体商品   2001 虚拟商品
                        imgs_lists: lb.join(","), //商品轮播图url地址， 逗号分割
                        put_on_sale: this.ruleForm.put_on_sale,
                        unconditional_return: this.ruleForm.unconditional_return,
                        warehouse_address_id: this.ruleForm.warehouse_address_id,
                        send_goods_time: this.ruleForm.send_goods_time,
                        attribute: [
                            { required: true, name: "型号", value: this.ruleForm.attribute.marque },
                            { required: true, name: "商品重量", value: this.ruleForm.attribute.net_weight },
                            { required: true, name: "包装尺寸", value: this.ruleForm.attribute.volume },
                            { required: true, name: "产地", value: this.ruleForm.attribute.country_of_origin },
                        ],
                    };
                    if (parseInt(this.Spec) == 1) {
                        data.merchandise_inventory = this.ruleForm.kc;
                    }
                    if (parseInt(this.yf) == 1) data.express_fee_price = this.yfprice; //快递费费用
                    this.proUpdate(data).then((res) => {
                        this.disabledOK = false;
                        if (res.code == 1) {
                            if (parseInt(this.Spec) == 2) {
                                let list = [];
                                let ite = this.ruleForm.guigeList;
                                for (let i = 0; i < this.Guigename.length; i++) {
                                    // let items=[];
                                    for (let j = 0; j < ite.length; j++) {
                                        let items = {};
                                        if (this.Guigename[i].id == ite[j].ggname) {
                                            let a = [];
                                            for (let z = 0; z < ite[j].childern2.length; z++) {
                                                a.push({
                                                    id: ite[j].childern2[z].id,
                                                    attributes_title1: ite[j].value, //属性值1 标题
                                                    attributes_title2: ite[j].childern2[z].value, //属性值2 标题
                                                    attributes_name_id: ite[j].childern2[z].name, //属性值2 对应的商品属性名id
                                                    merchandise_inventory: ite[j].childern2[z].kc, //库存
                                                    prices_defaults: ite[j].childern2[z].scj, //标准价
                                                    prices_mains: ite[j].childern2[z].xsj, //零售价
                                                    sorting: z, //排序， 从低到高
                                                });
                                            }
                                            items = {
                                                attributes_name_id: ite[j].ggname,
                                                attributes_list: a,
                                            };
                                        }
                                        if (items.attributes_list && items.attributes_list.length > 0) list.push(items);
                                    }
                                }
                                let opt = {
                                    token: this.$store.state.token, //商户token
                                    id: res.data.id, //商品id
                                    list: list,
                                };
                                if (this.deleteId.length > 0) opt.dellist = this.deleteId;
                                this.insertGuige(opt).then((msg) => {
                                    if (msg.code == 1) {
                                        this.$message.success("编辑成功!");
                                        this.$emit("updateOk", 1);
                                    } else {
                                        this.$message.error(msg.msg);
                                    }
                                });
                            } else {
                                this.$message.success("编辑成功!");
                                this.$emit("updateOk", 1);
                            }
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        quxiao() {
            this.$emit("updateOk");
        },
        getGuival(val) {
            for (let i = 0; i < this.Guigename.length; i++) {
                if (this.Guigename[i].id == val) {
                    return this.Guigename[i].title;
                }
            }
        },
        leixChange() {
            this.getGoodLei({
                token: this.$store.state.token,
                classifys_type_id: parseInt(this.ruleForm.region),
            }).then((res) => {
                if (res.code == 1) {
                    this.customers = res.data.treeData;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        bindName() {
            this.getGuiNameList({
                token: this.$store.state.token, //必填 商户验证token
                column: ["id", "title"], //非必填  展示字段
                filter: {}, //非必填  查询条件
                offset: 0, //从第几条开始取， 0代表从第一条开始取
                limit: 0, //每页取多少tiao
            }).then((res) => {
                if (res.code == 1) {
                    this.Guigename = res.data.list;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        initTable() {
            this.tableData.splice(0, this.tableData.length);
            for (let i = 0; i < this.ruleForm.guigeList.length; i++) {
                for (let j = 0; j < this.ruleForm.guigeList[i].childern2.length; j++) {
                    this.tableData.push({
                        name: this.ruleForm.guigeList[i].value + "*" + this.ruleForm.guigeList[i].childern2[j].value,
                        xsj: this.ruleForm.guigeList[i].childern2[j].xsj,
                        scj: this.ruleForm.guigeList[i].childern2[j].scj,
                        kc: this.ruleForm.guigeList[i].childern2[j].kc,
                    });
                }
            }
        },
        insertGgm() {
            this.insertGuiName({
                token: this.$store.state.token, //必填  商户登录后的token
                title: this.guititle, //必填 规格名称
            }).then((res) => {
                if (res.code == 1) {
                    this.bindName();
                    this.$message.success("添加成功");
                    this.guititle = "";
                    this.insertggm = false;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        insertYI() {
            if (this.ggname != "" && this.ggvalue != "") {
                let a = "";
                let kg = 0;
                for (let i = 0; i < this.ruleForm.guigeList.length; i++) {
                    if (this.ruleForm.guigeList[i].ggname == this.ggname) {
                        a = this.ruleForm.guigeList[i].gg2name;
                        kg = 1;
                    }
                    console.log(this.ruleForm.guigeList[i].ggname, this.ggname);
                }
                if (kg == 1) {
                    //代表之前添加过
                    let items = this.ruleForm.guigeList[this.ruleForm.guigeList.length - 1];
                    console.log(items, "items");
                    if (items.childern2.length > 0) {
                        //判断上一个房间里面的值
                        this.ruleForm.guigeList.push({
                            ggname: this.ggname, //规格名id
                            value: this.ggvalue, //规格值
                            gg2name: a,
                            gg2value: "",
                            namein: "",
                            childern2: [],
                        });
                    }
                } else {
                    this.ruleForm.guigeList.push({
                        ggname: this.ggname,
                        value: this.ggvalue,
                        gg2name: a,
                        gg2value: "",
                        namein: "",
                        childern2: [],
                    });
                }

                this.ggvalue = "";

                // item.gg2name
            } else {
                this.$message.warning("请填写规格名称！");
            }
        },
        insertER(item) {
            if (item.gg2name != "" && item.gg2value != "") {
                item.childern2.push({
                    id: 0,
                    name: item.gg2name,
                    value: item.gg2value,
                    xsj: "",
                    scj: "",
                    kc: "",
                });
                item.gg2value = "";
            }
        },
        deleteers(item) {
            for (let i = 0; i < item.childern2.length; i++) {
                if (item.childern2[i].id != 0) {
                    this.deleteId.push(item.childern2[i].id);
                }
            }
            item.childern2.splice(0, item.childern2.length);
        },
        deleteER(item, child) {
            if (child.id != 0) this.deleteId.push(child.id);
            item.childern2.splice(item.childern2.indexOf(child), 1);
        },
        deleteYI(item) {
            for (let i = 0; i < item.childern2.length; i++) {
                if (item.childern2[i].id != 0) {
                    this.deleteId.push(item.childern2[i].id);
                }
            }
            this.ruleForm.guigeList.splice(this.ruleForm.guigeList.indexOf(item), 1);
        },
        handleChange1(file, fileList) {
            var formdata = new FormData();
            formdata.append("formdata", file.raw);
            this.ruleForm.zhuFile = fileList;
            this.uploadFile(formdata).then((res) => {
                if (res.code == 1) {
                    this.$message.success("上传成功！");
                    this.ruleForm.imgs_mains = res.data.formdata_details[0].urls;
                } else {
                    this.$message({
                        type: "warning",
                        message: res.msg,
                    });
                }
            });
        },
        handleChange2(file, fileList) {
            var formdata = new FormData();
            formdata.append("formdata", file.raw);
            this.ruleForm.lbFile = fileList;
            this.uploadFile(formdata).then((res) => {
                if (res.code == 1) {
                    this.$message.success("上传成功！");
                    this.ruleForm.imgs_lists.push({
                        file: file,
                        url: res.data.formdata_details[0].urls,
                    });
                } else {
                    this.$message({
                        type: "warning",
                        message: res.msg,
                    });
                }
            });
        },
        handleRemove1(file, fileList) {
            this.ruleForm.zhuFile = this.ruleForm.zhuFile.filter((item) => {
                return item != file;
            });
        },
        handleRemove2(file, fileList) {
            this.ruleForm.imgs_lists = this.ruleForm.imgs_lists.filter((item) => {
                if (item.file == "1") {
                    return item.url != file.url;
                } else return item.file != file;
            });
        },
        handleChange3(file, fileList) {
            var formdata = new FormData();
            formdata.append("formdata", file.raw);
            this.ruleForm.detailFile = fileList;
            this.uploadFile(formdata).then((res) => {
                if (res.code == 1) {
                    this.$message.success("上传成功！");
                    this.ruleForm.goods_detail_imgs_id.push({
                        file: file,
                        id: res.data.formdata_details[0].id,
                    });
                } else {
                    this.$message({
                        type: "warning",
                        message: res.msg,
                    });
                }
            });
        },
        handleRemove3(file, fileList) {
            this.ruleForm.goods_detail_imgs_id = this.ruleForm.goods_detail_imgs_id.filter((item) => {
                if (item.file == "1") {
                    return item.url != file.url;
                } else return item.file != file;
            });
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
    },
};
</script>
<style lang='scss' scoped>
.demo-ruleForm {
    max-height: 600px;
    height: 600px;
    overflow-y: auto;
    overflow-x: hidden;
    &::-webkit-scrollbar-track-piece {
        background: #d3dce6;
    }
    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-thumb {
        background: #99a9bf;
        border-radius: 20px;
    }
}
.mf {
    ::v-deep .el-upload--picture-card {
        display: none !important;
    }
}
.bg {
    padding: 24px;
    padding-bottom: 4px;
    background: #f5f5f5;
    & > .el-row {
        margin: 0;
        .el-col {
            height: 36px;
            line-height: 36px;
            margin-bottom: 20px;
            text-align: right;
            label {
                padding-right: 14px;
                display: inline-block;
            }
        }
    }
}
::v-deep .close .el-input__validateIcon {
    display: none !important;
}
</style>